export const mockAttendanceHistory = [
  {
    id: '1',
    personalId: '1',
    personalName: 'Carlos Rodríguez',
    date: new Date().toISOString().split('T')[0],
    checkIn: '08:30',
    checkOut: '17:30',
  },
  {
    id: '2',
    personalId: '2',
    personalName: 'María González',
    date: new Date().toISOString().split('T')[0],
    checkIn: '08:45',
    checkOut: '17:45',
  },
  {
    id: '3',
    personalId: '3',
    personalName: 'Juan Martínez',
    date: new Date().toISOString().split('T')[0],
    checkIn: '08:00',
    checkOut: '18:00',
  },
  {
    id: '4',
    personalId: '4',
    personalName: 'Ana López',
    date: new Date().toISOString().split('T')[0],
    checkIn: '09:00',
    checkOut: null,
  },
  {
    id: '5',
    personalId: '5',
    personalName: 'Pedro Sánchez',
    date: new Date().toISOString().split('T')[0],
    checkIn: '10:00',
    checkOut: null,
  },
  {
    id: '6',
    personalId: '1',
    personalName: 'Carlos Rodríguez',
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    checkIn: '08:30',
    checkOut: '17:30',
  },
  {
    id: '7',
    personalId: '2',
    personalName: 'María González',
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    checkIn: '08:45',
    checkOut: '17:45',
  },
  {
    id: '8',
    personalId: '6',
    personalName: 'Laura Fernández',
    date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
    checkIn: '09:00',
    checkOut: '18:00',
  }
];
